export default {
  baseURL: "https://api.quoteyrating.nerivon.cloud/",
};
